<template>
  <div 
    @click="$emit('click')"
    :class="[
      'p-4 rounded-lg border-1 border-solid border-gray-200 dark:border-gray-700 transition-all duration-200 cursor-pointer h-full',
      selected 
        ? 'bg-primary-50 dark:bg-primary-900/20 border-primary-300 dark:border-primary-600'
        : 'border-gray-200 dark:border-gray-700 hover:border-primary-300 dark:hover:border-primary-600 hover:shadow-md'
    ]"
    role="button"
    :aria-pressed="selected"
    :aria-label="`Select ${team.name} team`"
  >
    <div class="flex items-center gap-3 w-full">
      <!-- Team Icon -->
      <div class="w-8 h-8 bg-gradient-to-br from-primary-500 to-primary-600 dark:from-primary-600 dark:to-primary-700 rounded-lg flex items-center justify-center flex-shrink-0" aria-hidden="true">
        <Icon name="team" class="w-5 h-5 text-white" />
      </div>
      
      <!-- Team Name and Project Count -->
      <div class="flex flex-col gap-1.5 flex-1 min-w-0">
        <h5 class="text-base truncate font-semibold text-gray-900 dark:text-white leading-tight m-1">
          {{ team.name }}
        </h5>
        <HLTag 
          size="sm"
          color="blue"
          round
          :interactive="false"
          :bordered="false"
          class="w-fit"
        >
          {{ projectCount }} {{ projectCount === 1 ? 'project' : 'projects' }}
        </HLTag>
      </div>
      
      <!-- Chevron Icon -->
      <Icon 
        name="chevronRight"
        class="w-5 h-5 text-gray-400 flex-shrink-0 transition-colors self-center"
        :class="{ 'text-primary-600 dark:text-primary-400': selected }"
        aria-hidden="true"
      />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { HLTag } from '@platform-ui/highrise'
import Icon from '@/components/ui/Icon.vue'

const props = defineProps({
  team: {
    type: Object,
    required: true
  },
  selected: {
    type: Boolean,
    default: false
  }
})

defineEmits(['click'])

const projectCount = computed(() => props.team.projects?.length || 0)
</script>

